import { LoaderCircle } from 'lucide-react';

interface LoadingStateProps {
  label: string;
  sublabel?: string;
  fullPage?: boolean;
}

/**
 * The one loading spinner every in-flight payment state renders through —
 * launching a gateway, waiting on Razorpay's script/modal, confirming
 * status on the callback page. `fullPage` centers it in the viewport
 * (a page-level wait); without it, it's sized for mounting inline where a
 * gateway's checkout UI is about to take over.
 */
export function LoadingState({ label, sublabel, fullPage }: LoadingStateProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 px-4 text-center ${
        fullPage ? 'min-h-screen py-6' : 'py-16'
      }`}
    >
      <LoaderCircle
        className="text-brand-deep-blue h-8 w-8 animate-spin"
        strokeWidth={2}
      />
      <div>
        <div className="text-brand-ink text-[15px] font-medium">{label}</div>
        {sublabel && (
          <div className="text-brand-slate-blue mt-1 max-w-[280px] text-sm">
            {sublabel}
          </div>
        )}
      </div>
    </div>
  );
}
